export default "__VITE_ASSET__CWsrNWU7__"